import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) =>
        {
            // If the user is authenticated...
            if ( authenticated )
            {
                // Redirect the user to the signed-in redirection
                return of(new RedirectCommand(router.parseUrl('/signed-in-redirect'), { replaceUrl: false }));
            }

            // Allow the access
            return of(true);
        }),
    );
};
